export default {
	SET_PROPERTY: 'SET_PROPERTY',
	SCRIPT: 'SCRIPT',
	CANCEL_EVENT: 'CANCEL_EVENT',
};

export const keyOperationsGrid = [
	{ value: 'OPERATION_SUM_GRID' },
	{ value: 'OPERATION_MEDIA_GRID' },
	{ value: 'OPERATION_MAX_GRID' },
	{ value: 'OPERATION_MIN_GRID' },
	{ value: 'OPERATION_COUNT_GRID' },
];

export const isOperationGrid = (value) => keyOperationsGrid.map((o) => o.value).includes(value || '');
